import type { FC } from 'react';
import type { RouteObject } from 'react-router-dom';
import { useRoutes } from 'react-router-dom';
import LoadComponent from '@/components/LoadComponent';
import { RoutePath } from '@/constants';
import Auth from './Auth';

const HomePage = () => import('@/pages/HomePage');
const ReferralManagement = () => import('@/pages/ReferralManagement');
const RefererInfoQuery = () => import('@/pages/ReferralManagement/components/RefererInfoQuery');
const RefereeInfoQuery = () => import('@/pages/ReferralManagement/components/RefereeInfoQuery');
const GiftManagement = () => import('@/pages/GiftManagement');
const PCNVoucherManagement = () => import('@/pages/PCNVoucherManagement');
const AfterSalesVoucherManagement = () => import('@/pages/PCNVoucherManagement/component/AfterSalesVoucherManagement');
const VoucherManagement = () => import('@/pages/VoucherManagement');
const VoucherRedemption = () => import('@/pages/VoucherManagement/components/VoucherRedemption');
const RedemptionRecords = () => import('@/pages/VoucherManagement/components/RedemptionRecords');
const RedemptionOthersRecords = () => import('@/pages/VoucherManagement/components/RedemptionOthersRecords');
const PCCCManagement = () => import('@/pages/PCCC');
const POCManagement = () => import('@/pages/POC');
const PicturePreview = () => import('@/pages/PicturePreview');
const NotAuthorized = () => import('@/pages/NotAuthorized');
const NotFound = () => import('@/pages/NotFound');

const routeList: RouteObject[] = [
  {
    path: RoutePath.LANDING_PAGE,
    element: <Auth />,
    children: [
      {
        index: true,
        element: <LoadComponent content={HomePage} />,
      },
      {
        path: RoutePath.RECOMMENDATION_MANAGEMENT,
        element: <LoadComponent content={ReferralManagement} />,
        children: [
          {
            index: true,
            element: <LoadComponent content={RefererInfoQuery} />,
          },
          {
            path: RoutePath.RECOMMENDATION_MANAGEMENT_REFEREE,
            element: <LoadComponent content={RefereeInfoQuery} />,
          },
        ],
      },
      {
        path: RoutePath.GIFT_MANAGEMENT,
        element: <LoadComponent content={GiftManagement} />,
      },
      {
        path: RoutePath.GIFT_MONITORING,
        element: <div></div>,
      },
      {
        path: RoutePath.PCN_VOUCHER_MANAGEMENT,
        element: <LoadComponent content={PCNVoucherManagement} />,
        children: [
          {
            index: true,
            element: <LoadComponent content={AfterSalesVoucherManagement} />,
          },
          {
            path: RoutePath.THIRD_PARTY_VOUCHER_MANAGEMENT,
            element: <div></div>,
          },
        ],
      },
      {
        path: RoutePath.VOUCHER_MANAGEMENT,
        element: <LoadComponent content={VoucherManagement} />,
        children: [
          {
            index: true,
            element: <LoadComponent content={VoucherRedemption} />,
          },
          {
            path: RoutePath.VOUCHER_REDEEM_RECORDS,
            element: <LoadComponent content={RedemptionRecords} />,
          },
          {
            path: RoutePath.VOUCHER_REDEEM_OTHERS_RECORDS,
            element: <LoadComponent content={RedemptionOthersRecords} />,
          },
        ],
      },
      {
        path: RoutePath.PCCC,
        element: <LoadComponent content={PCCCManagement} />,
      },
      {
        path: RoutePath.POC,
        element: <LoadComponent content={POCManagement} />,
      },
    ],
  },
  { path: '/picture', element: <LoadComponent content={PicturePreview} /> },
  {
    path: RoutePath.PAGE_NOT_AUTHORIZED,
    element: <LoadComponent content={NotAuthorized} />,
  },
  {
    path: '*',
    element: <LoadComponent content={NotFound} />,
  },
];

const RenderRouter: FC = () => {
  return useRoutes(routeList);
};

export default RenderRouter;
